import { createSlice } from "@reduxjs/toolkit";

export const familyDetailsSlice = createSlice({
  name: "familyDetails",
  initialState: {
    relativeTypeList: [],
    relativeList: [],
    rList: [],
    errors: {},
  },
  reducers: {
    setFirstName: (state, action) => {
      state.firstName = action.payload;
    },
    setMiddleName: (state, action) => {
      state.middleName = action.payload;
    },
    setLastName: (state, action) => {
      state.lastName = action.payload;
    },
    setRelativeTypeList: (state, action) => {
      state.relativeTypeList = action.payload;

      const rList = state.relativeList.map((r) => {
        const relativeType = state.relativeTypeList.find(
          (rt) => rt.code == r.relativeTypeId
        );

        r.relativeType = relativeType;

        return r;
      });

      state.relativeList = [
        ...state.relativeTypeList
          .filter(
            (rt) => !state.relativeList.find((r) => rt.code == r.relativeTypeId)
          )
          .map((relativeType) => {
            return {
              firstName: "",
              middleName: "",
              lastName: "",
              firstNameNep: "",
              middleNameNep: "",
              lastNameNep: "",
              relativeType,
              relativeTypeId: relativeType.code,
              op: "N",
            };
          }),
        ...rList,
      ];

      state.relativeList = state.relativeList.sort(orderRelative);
    },
    setFamilyValue: (state, action) => {
      const data = state.relativeList[action.payload.index];
      data[action.payload.key] = action.payload.value;
      data.pop = "U";

      state.errors[data.relativeTypeId + 'FamilyError'] = null;
    },
    setFamilyError: (state, action) => {
      const section = action.payload.section;

      state.errors['FamilyError' + section.key] = action.payload.message;
    },
    setFamilyDetailData: (state, action) => {
      state.relativeList = action.payload.map((r) => {
        const relativeType =
          state.relativeTypeList.find((rt) => rt.code == r.relativeTypeId) ||
          {};

        return {
          relativeType,
          relativeTypeId: relativeType.code,
          ...r,
          op: "N",
        };
      });

      state.relativeTypeList
        .filter((relative) => {
          return !state.relativeList.find(
            (r) => r.relativeTypeId == relative.code
          );
        })
        .forEach((relativeType) => {
          state.relativeList.push({
            relativeType,
            relativeTypeId: relativeType.code,
            firstName: "",
            middleName: "",
            lastName: "",
            firstNameNep: "",
            middleNameNep: "",
            lastNameNep: "",
            op: "N",
          });
        });

      state.relativeList = state.relativeList.sort(orderRelative);
      state.errors = {};
    },
    resetFamilyDetailData: (state, action) => {
      state.rList = [];
      state.relativeList = [
        ...state.relativeList.filter(
          (r) => (r.relativeTypeId && !r.pop) || r.pop === "N"
        ),
        ...action.payload.map((r) => {
          const relativeType =
            state.relativeTypeList.find((rt) => rt.code == r.relativeTypeId) ||
            {};

          return {
            ...r,
            relativeType,
            relativeTypeId: relativeType.code,
            op: "N",
            pop: "N",
          };
        }),
      ];

      state.relativeList = state.relativeList.sort(orderRelative);
    },
    clearFamilyData: (state, action) => {
      state.op = "N";
      state.relativeList.forEach((r) => (r.op = "N"));
    },
    setFamilyDetailsError: (state, action) => {
      state.errors[action.payload.key] = action.payload;
    },
    clearFamilyDetailsError: (state, action) => {
      // state.errors[action.payload.key] = null;
      state.errors = {};
    },
    removeFamily: (state, action) => {
      if (state.relativeList[action.payload].id)
        state.rList.push(state.relativeList[action.payload].id);

      state.relativeList.splice(action.payload, 1);
    },
    addEmptyFamily: (state, action) => {
      const relativeType =
        state.relativeTypeList.find((rt) => rt.code == action.payload) || {};
      state.relativeList.push({
        relativeType,
        relativeTypeId: action.payload,
        firstName: "",
        middleName: "",
        lastName: "",
        firstNameNep: "",
        middleNameNep: "",
        lastNameNep: "",
        op: "I",
      });

      state.relativeList = state.relativeList.sort(orderRelative);
    },
  },
});

export const {
  removeFamily,
  addEmptyFamily,
  clearFamilyData,
  resetFamilyDetailData,
  setFamilyDetailData,
  setFamilyValue,
  setFamilyError,
  setRelativeTypeList,
  setFirstName,
  setMiddleName,
  setLastName,
  setFamilyDetailsError,
  clearFamilyDetailsError
} = familyDetailsSlice.actions;

const orderRelative = (r1, r2) => {
  if (r1.relativeTypeId === r2.relativeTypeId) return 0;

  const r1Index = relationOrderedList.indexOf(r1.relativeTypeId);
  const r2Index = relationOrderedList.indexOf(r2.relativeTypeId);

  return r2Index - r1Index;
};

const relationOrderedList = ["D", "S", "SP", "M", "F", "GF"];

export default familyDetailsSlice.reducer;
